export const FilterProp = Object.freeze({
    Id: 'id',
    ColumnField: 'columnField',
    ComparatorField: 'comparatorField',
    ValueField: 'valueField',
});
